import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import { SabiasQueNY } from "./nyHelpers";

// Template85: Día 5 Del Empire State al SoHo (Page15). Contenido desde page.
const Template85 = ({
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const parseSabiasQueItem = (html) => {
		if (!html) return null;
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, "text/html");
		const p = doc.querySelector("p");
		if (!p) return null;
		const text = (p.textContent ?? p.innerText ?? "").trim();
		if (!text) return null;
		const emojiMatch = text.match(/^([^\s]+)\s+(.*)/s);
		if (emojiMatch)
			return { icono: emojiMatch[1], texto: emojiMatch[2].trim() };
		return null;
	};

	const title = page?.texts?.[0]?.content;
	const heroH1 = page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;
	const empireH3 = page?.texts?.[3]?.content;
	const empireP = page?.texts?.[4]?.content;
	const macysH3 = page?.texts?.[5]?.content;
	const macysP = page?.texts?.[6]?.content;
	const sabiasQueMacys = parseSabiasQueItem(page?.texts?.[7]?.content);
	const heraldH3 = page?.texts?.[8]?.content;
	const heraldP = page?.texts?.[9]?.content;
	const flatironH3 = page?.texts?.[10]?.content;
	const flatironP = page?.texts?.[11]?.content;
	const sabiasQueFlatiron = parseSabiasQueItem(page?.texts?.[12]?.content);
	const harryRaw = page?.texts?.[13]?.content;
	const harryTitle = harryRaw?.includes("\n")
		? harryRaw.split("\n")[0]
		: harryRaw;
	const harryBody = harryRaw?.includes("\n")
		? harryRaw.split("\n").slice(1).join(" ").trim()
		: "";

	const empirePortadaSrc = getImageSrc("empire-portada");
	const empireStickerSrc = getImageSrc("empire-sticker");
	const empireSrc = getImageSrc("empire");
	const macysSrc = getImageSrc("macys");
	const flatironSrc = getImageSrc("flatiron");
	const harrySrc = getImageSrc("harry-potter");
	const logoSrc = getCanvasImageUrl("logo");

	const estiloH3 = {
		fontFamily: '"Poppins", sans-serif',
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const estiloP = {
		fontFamily: '"Poppins", sans-serif',
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				backgroundColor: "#f7f7f7",
				position: "relative",
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
				"& p": { marginTop: "0px !important", marginBottom: "0px !important" },
			}}
		>
			<div
				data-block-id="header"
				style={{
					backgroundColor: headerBackgroundColor || "#59c3d8",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontFamily: fontFamily || '"Poppins", sans-serif',
					fontSize: "14px",
					fontWeight: 700,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 9999,
				}}
			>
				{title}
				{logoSrc && (
					<img
						src={logoSrc}
						alt="logo"
						style={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</div>

			{empirePortadaSrc && (
				<div data-block-id="image-0" style={{ position: "relative" }}>
					<img
						src={empirePortadaSrc}
						alt="Empire State"
						style={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
					{empireStickerSrc && (
						<img
							src={empireStickerSrc}
							alt="sticker"
							style={{
								width: isSmallScreen ? 80 : 100,
								position: "absolute",
								bottom: isSmallScreen ? 60 : -10,
								right: isSmallScreen ? "auto" : 0,
								left: isSmallScreen ? 25 : "auto",
							}}
						/>
					)}
					{heroH1 && (
						<h1
							style={{
								fontFamily: '"Poppins", sans-serif',
								fontSize: 32,
								textAlign: "center",
								position: "absolute",
								bottom: 0,
								margin: 10,
								left: 20,
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{heroH1}
						</h1>
					)}
				</div>
			)}

			{intro && (
				<div data-block-id="text-1" style={{ padding: "10px 12px" }}>
					<p style={estiloP}>{intro}</p>
				</div>
			)}

			<div>
				{(empireH3 || empireP || empireSrc) && (
					<div data-block-id="text-2" style={{ display: "flex", gap: 16, padding: "0 12px" }}>
						{empireSrc && (
							<img
								src={empireSrc}
								alt="Empire State"
								style={{
									width: "40%",
									height: 100,
									objectFit: "cover",
									borderRadius: 12,
								}}
							/>
						)}
						<div style={{ width: "60%" }}>
							{empireH3 && <h3 style={estiloH3}>{empireH3}</h3>}
							{empireP && <p style={estiloP}>{empireP}</p>}
						</div>
					</div>
				)}
				{(macysH3 || macysP || macysSrc) && (
					<div
						data-block-id="text-3"
						style={{
							display: "flex",
							gap: 16,
							padding: "0 12px",
							marginTop: 12,
						}}
					>
						{macysSrc && (
							<img
								src={macysSrc}
								alt="Macy's"
								style={{
									width: "40%",
									height: 100,
									objectFit: "cover",
									borderRadius: 12,
								}}
							/>
						)}
						<div style={{ width: "60%", position: "relative" }}>
							{macysH3 && <h3 style={estiloH3}>{macysH3}</h3>}
							{macysP && <p style={estiloP}>{macysP}</p>}
							{sabiasQueMacys && (
								<div
									style={{
										position: "absolute",
										top: isSmallScreen ? "auto" : -35,
										bottom: isSmallScreen ? -40 : "auto",
										right: "65%",
										zIndex: 999,
									}}
								>
									<SabiasQueNY
										icono={sabiasQueMacys.icono}
										texto={sabiasQueMacys.texto}
									/>
								</div>
							)}
						</div>
					</div>
				)}
				{(heraldH3 || heraldP) && (
					<div data-block-id="text-4" style={{ padding: "0px 12px", paddingTop: 14 }}>
						<div
							style={{
								backgroundColor: "#e0f7fa",
								padding: 12,
								borderRadius: 12,
								display: "flex",
								gap: 16,
								alignItems: "center",
							}}
						>
							<div style={{ width: "100%" }}>
								{heraldH3 && <h3 style={estiloH3}>{heraldH3}</h3>}
								{heraldP && <p style={estiloP}>{heraldP}</p>}
							</div>
						</div>
					</div>
				)}
				{(flatironH3 || flatironP || flatironSrc) && (
					<div
						data-block-id="text-5"
						style={{
							display: "flex",
							gap: 16,
							padding: "0 12px",
							marginTop: 12,
							position: "relative",
						}}
					>
						{flatironSrc && (
							<img
								src={flatironSrc}
								alt="Flatiron"
								style={{
									width: "40%",
									height: 100,
									objectFit: "cover",
									borderRadius: 12,
								}}
							/>
						)}
						<div style={{ width: "60%" }}>
							{flatironH3 && <h3 style={estiloH3}>{flatironH3}</h3>}
							{flatironP && <p style={estiloP}>{flatironP}</p>}
						</div>
						{sabiasQueFlatiron && (
							<div
								style={{
									position: "absolute",
									top: isSmallScreen ? "auto" : -35,
									bottom: isSmallScreen ? -40 : "auto",
									right: "33%",
									zIndex: 999,
								}}
							>
								<SabiasQueNY
									icono={sabiasQueFlatiron.icono}
									texto={sabiasQueFlatiron.texto}
								/>
							</div>
						)}
						{harrySrc && (harryTitle || harryBody) && (
							<>
								<img
									src={harrySrc}
									alt="Harry Potter"
									style={{
										width: 100,
										position: "absolute",
										bottom: isSmallScreen ? -120 : -20,
										left: -30,
									}}
								/>
								<div
									style={{
										position: "absolute",
										bottom: isSmallScreen ? -80 : 32,
										left: isSmallScreen ? 40 : 10,
										backgroundColor: "#fff8db",
										border: "2px solid #f5c400",
										borderRadius: "16px 16px 16px 0px",
										padding: "10px 12px",
										fontSize: 11,
										fontFamily: '"Poppins", sans-serif',
										color: "#444",
										boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
										maxWidth: isSmallScreen ? 200 : 115,
									}}
								>
									{harryTitle && <strong>{harryTitle}</strong>}
									{harryBody && (
										<>
											<br />
											{harryBody}
										</>
									)}
								</div>
							</>
						)}
					</div>
				)}
			</div>
		</Box>
	);
};

export default Template85;
